<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1 mydiv" id="autumn">
<h1>Autumn</h1>
<p>Go home to your mother</p>
<p>And tell her you love her</p>
<p>Follow the breeze</p>
<p>To warm autumn leaves</p>
<p>Live each day</p>
<p>Ignore all winter</p>
<p>Soon will be springtime</p>
<p>Birds up above</p>
<p>See the cold sky and be at ease</p>
<p>As temporary as the bare autumn trees</p>
<p>Rise early for spring</p>
<p>The birds as they sing</p>
<p>Watch the doe deer as they tread through the fall</p>
<p>Have love, joy and laughter and see everyone</p>
<p>Do not leave last that which must be done</p>
<p>Look forward to hot summers</p>
<p>The flame of the sun</p>
<p>For all is as brief as</p>
<p>The cold autumn breeze.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?36012338